import { useState, useEffect } from "react";
import "assets/home.scss";
import Services from "components/home/Services";
import Product from "common/product/Product";
import GroupViewContainer from "common/Group-View/GroupViewContainer";
import Blog from "common/blog/Blog";
import Comments from "components/home/Comments";
import img from "assets/images/home/1458.png";
import mainPic from "assets/images/home/homeLaptop.jpg";
import aboutUs from "assets/images/home/aboutUSBg.jpg";

import img2 from "assets/images/home/GRC_preview.png";
import img4 from "assets/images/home/laptop.png";
import cog from "assets/images/home/cog.png";
import guarantee from "assets/images/home/guarantee.png";
import paymentMethod from "assets/images/home/payment-method.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Helmet from "react-helmet";
import { pageSectionId } from "constants/constants";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { NavLink, Link } from "react-router-dom";

import { useContext } from "react";
import Search from "components/main/Search";
const serviceData = [
  {
    img: img4,
    title: "تعمیرات لپ تاپ",
    description:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، ",
  },
  {
    img: paymentMethod,
    title: "خرید و فروش",
    description:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، ",
  },
  {
    img: guarantee,
    title: "گارانتی سه ماهه رایگان",
    description:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، ",
  },
  {
    img: cog,
    title: "تامین قطعات",
    description:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، ",
  },
];
const Home = () => {
  const auth = useContext(WithAuthentication);

  const GroupViewData = [
    {
      Component: Product,
      numberOf: 4,
      title: "محصولات",
      type: 0,
      id: 2,
      Color: "#FF0000",
      moreText: "محصولات بیشتر",
      idConfig: pageSectionId.homeFirstProduct,
    },
    {
      Component: Blog,
      numberOf: 4,
      title: "بلاگ",
      type: 1,
      id: 1,
      className: "display-GroupView",
      moreText: "مطالب بیشتر",
      idConfig: pageSectionId.homeSecondBlog,
    },
  ];

  return (
    <div dir="rtl" className="home p-0">
      <Helmet>
        <title>خانه</title>
      </Helmet>
      <div
        className="position-relative search-input mx-auto display-input d-none mt-3"
        style={{ width: "70%" }}
      >
        <Search></Search>
      </div>
      <div className="d-flex flex-row header-title mb-5 ">
        <div className="main-img align-self-center text-center">
          <img src={mainPic} className="my-auto" alt width="90%" />
        </div>
        <div
          className="text-center justify-content-around me-4 title-desc"
          style={{ marginTop: "8%", width: "100%" }}
        >
          <p className="title-color" style={{ fontSize: 45 }}>
            <strong>مرکز تعمیرات تخصصی لپ تاپ گلستان</strong>
          </p>
          <div className="title-text" style={{ padding: "10px 14%" }}>
            <p>
              خرید و تعمیرات لپ‌تاپ و سیستم‌های رایانه‌ای خانگی و اداری خود را
              با اطمینان به ما بسپارید.
              <br />
              مرکز تعمیرات تخصصی GRC با ۱۰سال سابقه تخصصی در بخش تعمیرات و فروش
              لپ‌تاپ و سیستم‌های رایانه‌ای خانگی و اداری در خدمت شماست.{" "}
            </p>
          </div>

          {!auth.isLogged ? (
            <button
              className="btn text-white btn-join"
              style={{
                backgroundColor: "#5F7ED9",
                // height: 50,
                // width: "43%",
                fontSize: "14px",
              }}
              data-bs-toggle="modal"
              data-bs-target="#ModalNumber"
            >
              پیوستن به ما
            </button>
          ) : (
            <NavLink
              to={`${
                auth.userInfo.userType == 1
                  ? "/customer-panel/orders"
                  : "/admin-panel/orders"
              }`}
            >
              <button
                className="btn text-white btn-join"
                style={{
                  backgroundColor: "#5F7ED9",
                  // height: 50,
                  // width: "43%",
                  fontSize: "14px",
                }}
              >
                ورود به داشبورد
              </button>
            </NavLink>
          )}
        </div>
      </div>
      <h2 className="title-color text-center">
        <strong>ما بهترین خدمات را ارائه میدهیم </strong>
      </h2>
      <div className="d-flex flex-row flex-wrap container-item justify-content-center pt-4">
        {serviceData.map((value) => {
          return (
            <Services
              title={value.title}
              description={value.description}
              img={value.img}
            />
          );
        })}
      </div>
      <div className="bg-white shadow d-flex flex-row container-item-sm py-2 d-none mt-4">
        {serviceData.map((value) => {
          return (
            <div className="text-center border-end item">
              <div className="item-title">
                <img src={value.img} width={50} alt />
                <h5>{value.title}</h5>
              </div>
            </div>
          );
        })}
      </div>
      <div>
        <GroupViewContainer GroupViewData={GroupViewData} />
      </div>
      <div className="image-about"></div>
      <div className="w-100 about-us text-center d-flex my-3">
        {/* <h1 className="aboutme text-white mt-3" style={{ fontSize: 40 }}>
          درباره ما
        </h1> */}

        <p
          className=" mx-auto  my-auto px-4 text-width text"
          style={{
            color: "#d5b254 ",
            lineHeight: 2.5,
            textAlign: "justify",
            lineHeight: "25px",
            paddingTop: "15px",
            paddingBottom: "15px",
          }}
        >
          لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با
          استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در
          ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و
          کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی
          در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می
          و آینده، شناخت فراوان جامعه و متخصصان رطلبد، تا با نرم افزارها شناخت
          درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می و آینده،
          شناخت فراوان جامعه و متخصصان رطلبد، تا با نرم بیشتری را برای طراحان
          رایانه
        </p>
      </div>
      <div className="container-item4 text-center mb-5">
        <div className="position-relative mx-auto main-title4 pt-3">
          <h1 className="fs-1 text-white">نظرات مشتریان</h1>
        </div>
        <div
          className="row  justify-content-center"
          style={{ padding: "0 70px", textAlign: "center", width: "100%" }}
        >
          <Comments />
          <Comments />
          <Comments />
        </div>
      </div>
      <div className="container-item4-sm  text-center pb-4 d-none">
        <div className="position-relative  mx-auto main-title-s-4 pt-3">
          <h1 className="fs-1 text-white">نظرات مشتریان</h1>
        </div>
        <div className=" w-100">
          <div className="text-center">
            <Swiper
              modules={[Navigation, Pagination]}
              navigation={true}
              slidesPerView={1}
              slidesPerGroup={1}
              loop={true}
              spaceBetween={0}
              pagination={{ clickable: true }}
              className=" pb-5"
            >
              <SwiperSlide>
                <Comments />
              </SwiperSlide>
              <SwiperSlide>
                <Comments />
              </SwiperSlide>
              <SwiperSlide>
                <Comments />
              </SwiperSlide>
              <SwiperSlide>
                <Comments />
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
